import React from 'react'
import PropTypes from 'prop-types'
import { useShouldConditionallyRender } from '@morningtrain/react-helpers'
import useConstraint from '../hooks/use-constraint'

export default function WhenConstraint ({
  children,
  name,
  matches,
  negate
}) {
  const value = useConstraint(name)

  const [shouldRender] = useShouldConditionallyRender(value, matches, negate)

  return shouldRender ? children : null
}

WhenConstraint.propTypes = {
  /**
     * The parameter name to match the current route against.
     */
  name: PropTypes.string.isRequired,
  /**
     * The value to match the current parameter against.
     */
  matches: PropTypes.any,
  /**
     * Should the result be negated?
     */
  negate: PropTypes.bool
}
